import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38c2e8ae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=38c2e8ae&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=38c2e8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2e8ae",
  null
  
)

export default component.exports